@if (unusedTileData$ | async; as unusedTileData) {
  <div>
    <ziro-dashboard-tile
      [isLoading]="unusedTileData.isLoading"
      [tile]="unusedTileData.tileStatus"
    ></ziro-dashboard-tile>
  </div>
}
